import React from 'react';
import Joyride, { Step, STATUS, EVENTS, ACTIONS } from 'react-joyride';
import { useTutorialContext } from './tutorial.context';

export interface LifeCycleStep {
  [EVENTS.STEP_BEFORE]?: string | [string, number] | [string[], number];
  [EVENTS.STEP_AFTER]?: string | [string, number] | [string[], number];
  [EVENTS.TARGET_NOT_FOUND]?: string | [string, number] | [string[], number];
}

export interface CustomStep extends Step {
  // [key: string]: any
  [ACTIONS.NEXT]?: LifeCycleStep;
  [ACTIONS.PREV]?: LifeCycleStep;
}

export const Tutorial = () => {
  const { state, setState } = useTutorialContext();
  const { steps, stepIndex, run, triggers } = state;
  const joyRideCallback = (data: any) => {
    const { action, index, status, type, step } = data;
    const [trigger, delay] =
      step?.[action]?.[type] && Array.isArray(step?.[action]?.[type])
        ? step?.[action]?.[type]
        : [step?.[action]?.[type], 0];
    if (
      ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND] as string[]).includes(type)
    ) {
      if (trigger) {
        if (Array.isArray(trigger)) {
          for (var trg of trigger) {
            if (triggers?.[trg]) {
              triggers?.[trg]();
            }
          }
        } else if (triggers?.[trigger]) {
          triggers?.[trigger]?.();
        }
        if (type === EVENTS.TARGET_NOT_FOUND) {
          setState(currState => ({
            ...currState,
            tourActive: true,
            run: false,
          }));
        } else {
          setTimeout(function () {
            setState(currState => ({
              ...currState,
              stepIndex: index + (action === ACTIONS.PREV ? -1 : 1),
            }));
          }, delay);
        }
      } else {
        setState(currState => ({
          ...currState,
          stepIndex: index + (action === ACTIONS.PREV ? -1 : 1),
        }));
      }
    } else if (([EVENTS.STEP_BEFORE] as string[]).includes(type)) {
      if (trigger) {
        if (Array.isArray(trigger)) {
          for (const trg of trigger) {
            if (triggers?.[trg]) {
              triggers?.[trg]();
            }
          }
        } else if (triggers?.[trigger]) {
          triggers?.[trigger]?.();
        }
      }
    } else if (
      ([STATUS.FINISHED, STATUS.SKIPPED] as string[]).includes(status)
    ) {
      // Need to set our running state to false, so we can restart if we click start again.
      setState({ run: false, stepIndex: 0 });
      triggers?.close && triggers?.close();
    }
  };

  return (
    <Joyride
      callback={joyRideCallback}
      steps={steps}
      stepIndex={stepIndex}
      run={run}
      continuous
      disableCloseOnEsc
      disableOverlayClose
      scrollToFirstStep
      showProgress
      showSkipButton
      hideCloseButton
      hideBackButton
      locale={{
        back: 'Back',
        close: 'Close',
        last: 'Last',
        next: 'Next',
        open: 'Open the dialog',
        skip: 'Exit',
      }}
      styles={{
        options: {
          beaconSize: 50,
          primaryColor: '#83AD51',
          zIndex: 99999,
        },
        beacon: {
          zIndex: 99999,
        },
        spotlight: {
          border: '2px solid white',
        },
        buttonNext: {
          backgroundColor: '#83AD51',
          fontFamily: 'Poppins',
        },
        buttonBack: {
          color: '#83AD51',
          fontFamily: 'Poppins',
        },
        tooltip: {
          fontFamily: 'Poppins',
          zIndex: 99999,
        },
        buttonSkip: {
          fontFamily: 'Poppins',
        },
      }}
    />
  );
};
